module.exports = __webpack_public_path__ + "img/soln-phantom.61334acd.png";